import { evaluateInAppRpc } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { evaluatePublicRpc } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService';
import { logRavenException } from '../../errorUtils';
import { noAuthRpcClient, rpcClient } from '../../rpcClient';
export const fetchPurchaseMotions = ({
  isPublicUseCase,
  productApiNames,
  purchaseMotionLocation
}) => {
  const locations = [purchaseMotionLocation];
  const purchaseMotionByProductApiName = {};
  for (const productApiName of productApiNames) {
    purchaseMotionByProductApiName[productApiName] = 'TALK_TO_SALES';
  }
  let promiseError = undefined;
  const purchaseMotionsPromise = isPublicUseCase ? noAuthRpcClient.call(evaluatePublicRpc, {
    request: {
      productApiNames,
      locations
    }
  }) : rpcClient.call(evaluateInAppRpc, {
    request: {
      productApiNames,
      locations
    }
  });
  return purchaseMotionsPromise.then(response => {
    for (const [productApiName, purchaseMotionsByPriority] of Object.entries(response.purchaseMotionsMapping.productsByLocationString[purchaseMotionLocation].purchaseMotionsByProductApiName)) {
      purchaseMotionByProductApiName[productApiName] = purchaseMotionsByPriority.purchaseMotions[0];
    }
  }, error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchPurchaseMotions: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return purchaseMotionByProductApiName;
  });
};
export const fetchPurchaseMotionsByPriority = ({
  isPublicUseCase,
  productApiNames,
  purchaseMotionLocation
}) => {
  const locations = [purchaseMotionLocation];
  const purchaseMotionsByProductApiName = {};
  for (const productApiName of productApiNames) {
    purchaseMotionsByProductApiName[productApiName] = {
      purchaseMotions: ['TALK_TO_SALES']
    };
  }
  let promiseError = undefined;
  const purchaseMotionsPromise = isPublicUseCase ? noAuthRpcClient.call(evaluatePublicRpc, {
    request: {
      productApiNames,
      locations
    }
  }) : rpcClient.call(evaluateInAppRpc, {
    request: {
      productApiNames,
      locations
    }
  });
  return purchaseMotionsPromise.then(response => {
    const byLocation = response.purchaseMotionsMapping.productsByLocationString[purchaseMotionLocation];
    for (const [productApiName, purchaseMotionsByPriority] of Object.entries(byLocation.purchaseMotionsByProductApiName)) {
      purchaseMotionsByProductApiName[productApiName] = purchaseMotionsByPriority;
    }
  }, error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchPurchaseMotionsByPriority: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return purchaseMotionsByProductApiName;
  });
};